var map = {
	"./next-show-eng.json": "./src/assets/data/next-show-eng.json",
	"./next-show-hr.json": "./src/assets/data/next-show-hr.json",
	"./shows.json": "./src/assets/data/shows.json",
	"./shows_eng.json": "./src/assets/data/shows_eng.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	var module = __webpack_require__(id);
	return module;
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error('Cannot find module "' + req + '".');
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/data sync recursive \\.json$";